
import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button data-icon="fa fa-share-alt" data-tooltip="sharePage"></header-button>`;

export class HeaderShareComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {

        });
    }
}
